import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { Alert, Box, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { PATH_DASHBOARD } from 'src/routes/paths';
import {
  DONATION_ACTION,
  formatOccurrenceDate,
} from 'src/utils/donationAvailability';

export default function DonationAvailabilityNotice({ notice, donationId }) {
  const { t } = useTranslation();
  if (!notice) return null;

  const occurrenceDate = formatOccurrenceDate(notice.occurrence);
  const rescuePath =
    donationId && notice.rescueId
      ? PATH_DASHBOARD.viewPartialDonation(donationId, notice.rescueId)
      : null;

  let action = {
    to: PATH_DASHBOARD.findItems.donations,
    label: t('donations.unavailable.find-other-donations'),
  };
  if (rescuePath && notice.action === DONATION_ACTION.VIEW_RESCUE) {
    action = {
      to: rescuePath,
      label: t('donations.unavailable.view-your-rescue'),
    };
  } else if (
    rescuePath &&
    notice.action === DONATION_ACTION.VIEW_RESCUE_RECORD
  ) {
    action = {
      to: rescuePath,
      label: t('donations.unavailable.view-rescue-record'),
    };
  }

  return (
    <Alert
      severity="info"
      sx={{ mt: 2 }}
      action={
        <Button
          color="inherit"
          size="small"
          component={RouterLink}
          to={action.to}
        >
          {action.label}
        </Button>
      }
    >
      {t(notice.messageKey)}
      {occurrenceDate ? (
        <Box component="span" sx={{ display: 'block', opacity: 0.8 }}>
          {t('donations.unavailable.occurrence', { date: occurrenceDate })}
        </Box>
      ) : null}
    </Alert>
  );
}

DonationAvailabilityNotice.propTypes = {
  notice: PropTypes.shape({
    code: PropTypes.string,
    messageKey: PropTypes.string,
    action: PropTypes.string,
    occurrence: PropTypes.object,
    rescueId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  donationId: PropTypes.string,
};
